<template>
<div class="about">
  <v-layout row>
    <v-flex md12 class="mx-3">
      <filtro @carregar-dados="carregarDados"></filtro>
    </v-flex>
    <v-flex>
      <analisesPorcentagem :data="params"></analisesPorcentagem>
    </v-flex>
    <v-flex md12>
      <desempenho-individual :mParams="params"></desempenho-individual>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import filtro from './../components/filtro'
import desempenhoIndividual from './../components/desempenhoIndividual'
import analisesPorcenagemDashboard from '../components/analisesPorcenagemDashboard.vue'
// import am4themes_animated from '@amcharts/amcharts4/themes/animated'

// am4core.useTheme(am4themes_animated)

export default {
  data () {
    return {
      dados: '',
      params: null
    }
  },
  components: {
    desempenhoIndividual: desempenhoIndividual,
    filtro: filtro,
    analisesPorcentagem: analisesPorcenagemDashboard
  },
  methods: {
    limparDados () {
    },
    carregarDados (dados) {
      this.params = dados
      // this.carregarAnalise(dados)
    }
  }
}
</script>
